import { render, staticRenderFns } from "./AscPagePlotWrapper.vue?vue&type=template&id=126879ae&"
import script from "./AscPagePlotWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPagePlotWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPagePlotWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports